/* eslint-disable no-alert */
/* eslint-disable react/no-unused-state */
/* eslint-disable import/no-named-as-default-member */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import _ from 'lodash'
import { Form, Select, Input, Button } from 'semantic-ui-react'

import PartnerActions from '../../reducers/partnerReducer'
import RestaurantActions from '../../reducers/restaurantReducer'

class PartnerForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      familyName: '',
      firstName: '',
      tel: '',
      selectedRestaurant: null,
      selectedBranch: null,
      restoName: '',
      branchName: '',
    }
  }

  componentDidMount() {
    const { record, restaurantLoaded, fetchRestaurants } = this.props

    if (record !== undefined) {
      this.setPartnerData(record)
    }

    if (!restaurantLoaded) {
      fetchRestaurants()
    }
  }

  componentWillReceiveProps(nextProps) {
    const { history } = this.props

    if (nextProps.submittedSuccess) {
      history.push('/partners')
    }

    if (nextProps.record !== undefined) {
      this.setPartnerData(nextProps.record)
    }
  }

  setPartnerData(partner) {
    this.setState({
      familyName: partner.family_name,
      firstName: partner.first_name,
      tel: partner.tel,
      selectedRestaurant: partner.restaurant,
      selectedBranch: partner.branch,
      restoName: partner.restaurant_name,
      branchName: partner.branch_name,
    })
  }

  onSaveSuccess = () => {
    const { history } = this.props

    history.push('/partners')
  }

  onFormSubmit = () => {
    const { ...restState } = this.state
    const { savePartner } = this.props

    const phone = restState.tel

    if (phone.match(/(\+855)([0-9]{8,9})$/)) {
      return savePartner(restState, this.onSaveSuccess)
    }

    return alert('Phone number incorrect format. e.g +855xxxxxxxx')
  }

  onTextChange = (text, field) => {
    this.setState({ [field]: text })
  }

  onRestaurantChange = data => {
    const { restaurants } = this.props

    this.setState({
      selectedRestaurant: data.value,
      restoName: restaurants[data.value].name,
      selectedBranch: '',
      branchName: '',
    })
  }

  onBranchChange = data => {
    const { restaurants } = this.props
    const { selectedRestaurant } = this.state

    this.setState({
      selectedBranch: data.value,
      branchName: restaurants[selectedRestaurant].branches[data.value].name,
    })
  }

  getRestaurantOptions = () => {
    const { restaurants } = this.props

    const publishedRestaurants = _.filter(restaurants, resto => resto.status === 'publish')
    const orderByName = _.orderBy(publishedRestaurants, ['name'], ['asc'])

    const options = _.map(orderByName, data => ({
      key: data.key,
      text: data.name,
      value: data.key,
    }))

    return options
  }

  getBranchOptions = () => {
    const { selectedRestaurant } = this.state
    const { restaurants } = this.props

    const options = _.map(restaurants[selectedRestaurant].branches, (data, key) => ({
      key,
      text: data.name,
      value: key,
    }))

    return options
  }

  render() {
    const { familyName, firstName, tel, selectedRestaurant, selectedBranch } = this.state
    const { action, restaurants, restaurantLoading, loading } = this.props

    return (
      <Form loading={restaurantLoading || loading} onSubmit={() => this.onFormSubmit()}>
        <Form.Field>
          <Form.Field
            required
            label="Family Name"
            placeholder="Family Name"
            control={Input}
            value={familyName}
            onChange={e => this.onTextChange(e.target.value, 'familyName')}
          />
        </Form.Field>
        <Form.Field>
          <Form.Field
            required
            label="First Name"
            placeholder="First Name"
            control={Input}
            value={firstName}
            onChange={e => this.onTextChange(e.target.value, 'firstName')}
          />
        </Form.Field>
        <Form.Field>
          <Form.Field
            required
            label="Telephone"
            placeholder="+85512345678"
            disabled={action === 'Edit'}
            control={Input}
            value={tel}
            onChange={e => this.onTextChange(e.target.value, 'tel')}
          />
        </Form.Field>
        <Form.Field
          required
          control={Select}
          value={selectedRestaurant}
          options={this.getRestaurantOptions()}
          label={{ children: 'Restaurant', htmlFor: 'form-select-control-restaurant' }}
          placeholder="Restaurant"
          search
          searchInput={{ id: 'form-select-control-restaurant' }}
          onChange={(e, data) => this.onRestaurantChange(data)}
        />
        {selectedRestaurant &&
          restaurants[selectedRestaurant] &&
          _.size(restaurants[selectedRestaurant].branches) > 0 && (
            <Form.Field
              required
              control={Select}
              value={selectedBranch}
              options={this.getBranchOptions()}
              label={{ children: 'Branch', htmlFor: 'form-select-control-branch' }}
              placeholder="Branch"
              search
              searchInput={{ id: 'form-select-control-branch' }}
              onChange={(e, data) => this.onBranchChange(data)}
            />
          )}
        <Button type="submit">Save</Button>
      </Form>
    )
  }
}

const mapStateToProps = state => ({
  restaurants: state.restaurants.data,
  restaurantLoading: state.restaurants.loading,
  restaurantLoaded: state.restaurants.loaded,
  loading: state.partners.loading || state.menus.loading,
  submittedSuccess: state.partners.submitted && state.partners.success && !state.partners.loading,
})

const mapDispatchToProps = dispatch => ({
  savePartner: (params, callback) => dispatch(PartnerActions.savePartnerRequest(params, callback)),
  fetchRestaurants: () => dispatch(RestaurantActions.fetchRestaurantsRequest()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(PartnerForm))



// WEBPACK FOOTER //
// ./src/components/partners/form.js